import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function convertSnakeCaseToTitleCase(str: string): string {
  return str.replace(/_/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2").trim();
}